var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-window-list',{attrs:{"headers":_vm.headers,"title":"Listado de Tipos Identificacion","company":_vm.comdes,"addMethod":"itemsTipoIdentificacion","closeBaseWindow":"addTipoIdentificacion","titleAddMethod":"Agregar Tipos Identificacion","itemStoreName":"itemsTipoIdentificacion","loading":_vm.loadingResult,"activarEdicion":true,"activarBorrar":true,"activarInternalForm":true,"formProperties":{
    creacion: 'Creacion de Tipos Identificacion',
    edicion: 'Editar Tipos Identificacion',
    url: `/transjuma/TipoIdentificacion/`
  }},on:{"selected-row":_vm.handleEvent,"updated":_vm.updatedList}})
}
var staticRenderFns = []

export { render, staticRenderFns }